export default "__VITE_ASSET__CNlRlBAa__"